import { useEffect, useState} from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";

export default function ProjectListing() {
    const [allData, setAllData] = useState([]);
    const [visibleCount, setVisibleCount] = useState(8); // show 6 initially
    const [isLoadMore, setIsLoadMore] = useState(true);  

    useEffect(() => {
    const dataFetcher = async () => {
        try {
        const response = await axios.get(`${BaseUrl}/api/project`);
        // console.log("API response:", response.data);
        setAllData(response.data.data || []); 
        } catch (error) {
        console.error("Data fetch error:", error);
        }
    };

    dataFetcher();
    }, []);

    const handleLoadMore = () => {
        if (isLoadMore) {
        const newCount = Math.min(visibleCount + 4, allData.length);
        setVisibleCount(newCount);
        if (newCount >= allData.length) {
            setIsLoadMore(false);
        }
        } else {
        setVisibleCount(8); // show 8 initially
        setIsLoadMore(true);
        }
    };

    if (!allData) {
        return null;
    }

  return (
    <>
    <section className="project-head header-gap">
        <div className="container">
            <div className="row justify-content-center">  
                <div className="col-lg-5 col-sm-8">
                    <h1 className="heading">Projects</h1>
                    <p>Our interior design process for each project is completely unique. We take into consideration the client’s style, personality and specific needs to ensure their vision is executed perfectly.</p>
                </div>
            </div>
        </div>
    </section>


    <section className="project-list">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <div className="projectcard-row">
                        
                        {allData.slice(0, visibleCount).map((data, index) => (
                        <div className="project-card wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s" key={index}>
                            <Link to={`/project/${data.slug}`}>
                                <picture> 
                                    <img src={`${BaseUrl}${data.listing_image}`} loading="lazy" class="img-responsive" alt="Project"/>
                                </picture>
                                <div>
                                    <span>{data.count}</span>
                                    <p>{data.title}</p>
                                </div>
                            </Link>
                        </div>
                        ))}
                    </div>

                    {allData.length > 8 && (        
                    <div className="project-more">
                        <Link onClick={handleLoadMore} className="default-btn colored-btn">{isLoadMore ? "View More" : "View Less"} <Icons name="Longarrow_right"/></Link>
                    </div>
                    )}
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
